import { useState } from 'react';
import { RouterProvider } from '@tanstack/react-router';
import { apiConfig } from './env-exports';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { httpBatchLink, retryLink, TRPCClientError } from '@trpc/client';
import { trpc } from '@/data-loaders';
import { router } from './router';

const apiUri = apiConfig.apiBaseUri || window.location.origin;

export default function App() {
  const [queryClient] = useState(() => new QueryClient());
  const [trpcClient] = useState(() =>
    trpc.createClient({
      links: [
        retryLink({
          retry: ({ attempts, error }) => {
            const status = (error as TRPCClientError<any>)?.data?.httpStatus;

            return attempts <= 2 && (!status || status === 429 || (status >= 500 && status < 600));
          },
          retryDelayMs: (attempt: number) => {
            const base = 500 * Math.pow(2, attempt);
            const jitter = Math.floor(Math.random() * 100);
            return base + jitter;
          },
        }),
        httpBatchLink({
          url: `${apiUri}/api/trpc`,
        }),
      ],
    }),
  );

  return (
    <>
      <trpc.Provider client={trpcClient} queryClient={queryClient}>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </trpc.Provider>
    </>
  );
}
